module.exports = "/images/mq.svg?f0f43d01c2f5f103102f199ce0fbd95e";